/**
 * 暖通信息全局上下文
 */

import { useState } from "react";
import { PSection } from "@/commons/interface/speccommon/section";
import { PMaterial } from "@/commons/interface/speccommon/material";



export interface HavcStatus {
    sections: PSection[], 
    setSections: (value: PSection[]) => void,
    materials: PMaterial[], 
    setMaterials:  (value: PMaterial[]) => void,
}


export function useHavcService() {
    const [sections, setSections] = useState<PSection[]>([]); // 截面列表
    const [materials, setMaterials] = useState<PMaterial[]>([]); // 材料列表


    return {
        sections, setSections,
        materials, setMaterials,

    }

}